import config from 'config';
import { getCookie } from 'helpers';
import { InsurerCoinsurance, APIResponse } from 'types/Request';

interface GetCoinsurancesOptions {
  insurerId: number;
  practiceId: number;
}

export async function getCoinsurances(options: GetCoinsurancesOptions): Promise<InsurerCoinsurance[] | undefined> {
  try {
    const { insurerId, practiceId } = options;

    const url = new URL(`${ config.baseUrl }/insurers/${insurerId}/coinsurances/${practiceId}`);

    type Response = APIResponse<InsurerCoinsurance[]>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      return;
    }

    const content = await response.json() as Response;

    if (content.status !== 'ok') {
      if (content.code === 'CONNECTION_ERROR') {
        return;
      }

      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar los coseguros.');
    }

    return content.payload;
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar los coseguros.');
  }
}
